// src/components/layouts/renderers/ChoqueiFrame.tsx
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { ChoqueiConfig, LayoutRendererProps } from '@/lib/layouts/types';
import { layoutHeadlineCss, SYSTEM_SANS } from '@/lib/layouts/headlineStyle';
import { useLayerFont } from '@/hooks/use-layer-font';

export const ChoqueiFrame: React.FC<LayoutRendererProps<ChoqueiConfig>> = ({ config, media }) => {
  useLayerFont(config.headlineFontFamily, config.headlineFontUrl);
  return (
    <AbsoluteFill style={{ backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', padding: 60, fontFamily: SYSTEM_SANS }}>
      <div
        data-testid="choquei-brandbar"
        style={{ backgroundColor: config.accentColor, borderRadius: 16, minHeight: 110, display: 'flex', alignItems: 'center', paddingLeft: 28, paddingRight: 28, gap: 18, marginBottom: 36, flexShrink: 0 }}
      >
        {config.logoUrl ? (
          <img src={config.logoUrl} alt="" style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: 64, height: 64, borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.35)' }} />
        )}
        <span style={{ color: '#ffffff', fontSize: 52, fontWeight: 800, letterSpacing: 1 }}>
          {config.brandName}
        </span>
        <span style={{ color: '#ffffff', fontSize: 40, marginLeft: 4 }}>✓</span>
      </div>

      <div
        data-testid="layout-headline"
        data-autocut-over=""
        style={{
          fontWeight: 800,
          lineHeight: 1.25,
          marginBottom: 36,
          ...layoutHeadlineCss(config, { color: '#111111', fontSize: 56, fontFamily: SYSTEM_SANS }),
        }}
      >
        {config.headline}
      </div>

      <div style={{ flex: 1, minHeight: 0, width: '100%', borderRadius: 24, overflow: 'hidden', backgroundColor: '#000', position: 'relative' }}>
        {media}
      </div>

      <div style={{ display: 'flex', gap: 36, fontSize: 44, color: '#444', marginTop: 28, flexShrink: 0 }}>
        <span>♥</span><span>💬</span><span>↪</span>
      </div>
    </AbsoluteFill>
  );
};
